import { cn } from '@/utils'

export const StepsToggledOnIcon = ({
  className,
  color = '#1E1E1E',
}: {
  className?: string
  color?: string
}) => {
  return (
    <svg
      width="31"
      height="23"
      viewBox="0 0 31 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('stroke-gray-800', className)}
    >
      <path
        d="M12.3229 2.65364C12.0985 2.55239 11.8547 2.5 11.6081 2.5C11.3615 2.5 11.1178 2.55239 10.8934 2.65364L3.51369 5.97586C3.36089 6.04251 3.23097 6.15168 3.13977 6.29007C3.04856 6.42846 3 6.5901 3 6.7553C3 6.92051 3.04856 7.08215 3.13977 7.22054C3.23097 7.35893 3.36089 7.4681 3.51369 7.53475L10.902 10.8655C11.1264 10.9666 11.3702 11.0189 11.6167 11.0188C11.8633 11.0189 12.1071 10.9666 12.3315 10.8655L19.7198 7.54327C19.8729 7.47673 20.003 7.36756 20.0944 7.22907C20.1858 7.09059 20.2345 6.92878 20.2345 6.7634C20.2345 6.59801 20.1858 6.43621 20.0944 6.29772C20.003 6.15924 19.8729 6.05006 19.7198 5.98353L12.3229 2.65364Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 11.0186C2.9996 11.1815 3.04643 11.3411 3.13495 11.4785C3.22348 11.6159 3.34998 11.7253 3.49945 11.7937L10.905 15.1245C11.1282 15.2244 11.3704 15.2761 11.6154 15.2761"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 15.2778C2.9996 15.4408 3.04643 15.6004 3.13495 15.7378C3.22348 15.8752 3.34998 15.9846 3.49945 16.053L10.905 19.3838C11.1282 19.4837 11.3704 19.5355 11.6154 19.5355C11.8604 19.5355 12.1026 19.4837 12.3258 19.3838L14.1479 18.5643"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip0_368_20694)">
        <path
          d="M23.4724 17.9748C22.7601 18.5178 21.8929 18.8185 20.9974 18.8332C18.0807 18.8332 17 15.5 17 15.5C17.5183 14.5341 17.6512 13.6901 18.5224 13.0248M20.5 12C20.7868 11.9329 20.7054 11.9993 21 12C23 12 25 15 25 15C25 15.5 24.8454 15.5895 24.5 16M21.8807 16.3832C21.7663 16.506 21.6283 16.6045 21.475 16.6728C21.3216 16.7411 21.1561 16.7779 20.9883 16.7808C20.8204 16.7838 20.6537 16.7529 20.4981 16.69C20.3424 16.6272 20.201 16.5336 20.0823 16.4149C19.9636 16.2962 19.8701 16.1548 19.8072 15.9992C19.7443 15.8435 19.7134 15.6768 19.7164 15.509C19.7194 15.3411 19.7561 15.1756 19.8244 15.0223C19.8927 14.8689 19.9913 14.7309 20.1141 14.6165M17 11.5L25 19.5"
          stroke={color}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_368_20694">
          <rect
            width="10"
            height="10"
            fill="white"
            transform="translate(16 10.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
